import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "showPasswordIcon", "hiddenPasswordIcon"]

    toggleInput() {
        const input = this.inputTarget.querySelector('input')
        const type = input.type === "password" ? "text" : "password"
        input.type = type
        if (input.type === 'password') {
            this.showPasswordIconTarget.classList.add('hidden')
            this.hiddenPasswordIconTarget.classList.remove('hidden')
        } else {
            this.showPasswordIconTarget.classList.remove('hidden')
            this.hiddenPasswordIconTarget.classList.add('hidden')
        }
    }
}
